import React,{useEffect} from 'react'

const EditModal = () => {
    useEffect(() => {
        // Initialize intl-tel-input when the component mounts
        const input = document.querySelector("#mobileedit");
        const iti = window.intlTelInput(input, {
            preferredCountries: ["us", "gb", "in", "au"],  // Customize preferred countries
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js"  // For better validation and formatting
        });

        // Cleanup the intl-tel-input when the component unmounts
        return () => {
            if (iti) {
                iti.destroy();
            }
        };
    }, []);
  return (
    <div>
           <div className="modal fade" id="editModal" tabindex="-1" aria-labelledby="addLeadModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="addLeadModalLabel">Edit Lead</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                                <h6 className='font-semibold mb-3 '>Basic Details:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="project" className="form-label">Project (*)</label>
                                        <input type="text" className="form-control" id="project" placeholder="Enter project name" />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="sr-no" className="form-label">Sr No (*)</label>
                                        <input type="text" className="form-control" id="sr-no" placeholder="Enter Sr No" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="date" className="form-label">Date (*)</label>
                                        <input type="date" className="form-control" id="date" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label className="form-label">Approach (*)</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="approach" id="approach-direct" value="direct" />
                                                <label className="form-check-label" htmlFor="approach-direct">Direct</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="approach" id="approach-broker" value="broker" />
                                                <label className="form-check-label" htmlFor="approach-broker">Broker</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Mode (*)</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="mode" id="mode-walkin" value="walkin" />
                                                <label className="form-check-label" htmlFor="mode-walkin">Walk In</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="mode" id="mode-call" value="call" />
                                                <label className="form-check-label" htmlFor="mode-call">Call</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="mode" id="mode-other" value="other" />
                                                <label className="form-check-label" htmlFor="mode-other">Other</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Client Details Section */}
                            <div className='mb-3' style={{ borderTop: "2px solid #f0f0f0" }} />
                            <div className="second-section">
                                <h6 className='font-semibold mb-3'>Client Details:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="name" className="form-label">Name (*)</label>
                                        <input type="text" className="form-control" id="name" placeholder="Enter client name" />
                                    </div>
                                    <div className="col-md-4">
                                        <label for="mobile" className="form-label">Mobile No (*)</label>
                                        <input type="tel" className="form-control" id="mobileedit" placeholder="Enter mobile number" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="email" className="form-label">Email ID</label>
                                        <input type="email" className="form-control" id="email" placeholder="Enter email" />
                                    </div>
                                </div>

                                {/* Status Section */}
                                <div className='mb-3' style={{ borderTop: "2px solid #f0f0f0" }} />
                                <h6 className='font-semibold mb-3'>Status:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="status" className="form-label">Status (*)</label>
                                        <select className="form-select" id="status">
                                            <option value="" disabled selected>Select</option>
                                            <option value="HOT">HOT</option>
                                            <option value="WARM">WARM</option>
                                            <option value="COLD">COLD</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="stage" className="form-label">Stage (*)</label>
                                        <select className="form-select" id="stage">
                                            <option value="" disabled selected>Select</option>
                                            <option value="HOT">NEW INQUIRY (STAGE 1)</option>
                                            <option value="WARM">CONTACTED (STAGE 2)</option>
                                            <option value="COLD">QUALIFIED (STAGE 3)</option>
                                            <option value="COLD">SITE VISIT SCHEDULED (STAGE 4)</option>
                                            <option value="COLD">SITE VISIT COMPLETED (STAGE 5)</option>
                                            <option value="COLD">MEETING DONE (STAGE 6)</option>
                                            <option value="COLD">NEGOTIATION (STAGE 7)</option>
                                            <option value="COLD">BOOKED (STAGE 8)</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="response" className="form-label">Response (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="HOT">INTERESTED</option>
                                            <option value="WARM">NOT INTERESTED</option>
                                            <option value="COLD">WILL INFORM SOON</option>
                                            {/* Add other options here */}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Other sections */}
                            <div className='mb-3' style={{ borderTop: "2px solid #f0f0f0" }} />
                            <div className="fourth-section">
                                <h6 className='font-semibold mb-3'>Other:</h6>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <label htmlFor="remarks" className="form-label">Remarks (*)</label>
                                        <textarea className="form-control" id="remarks" rows="3"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default EditModal
